
import React ,{Component} from 'react';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/system'; 
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import {NavLink, Navigate  } from 'react-router-dom';
import axios from 'axios';

import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

import SyncAltIcon from '@mui/icons-material/SyncAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';

export default class  AddCustomerbox extends Component {
	 constructor(props) {
    super();
	
	
	
	 this.state = {
	 
	 
	search:'',order:'desc' ,orderBy:'cu_id',cu_id:0,billingaddress1:'',billingaddress2:'',billingcity:'',billingstate:'',billingpincode:'',shippingaddress1:'',shippingaddress2:'',shippingcity:'',shippingstate:'',shippingpincode:'',
	cuid:'',open1:false,country:'',countrydata:[],countrylabel:'Select Country',	  
        
      }
	 };
	 
 Customergetdata() {
	
  if(this.props.id!==0)
  {
	   axios.get(localStorage.getItem("ISIurl")+'ajaxcustomer.php?action=getall&cu_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
  
      cu_id:resp.data[0].cu_id,	
	billingaddress1:resp.data[0].cu_billingaddress1,
	billingaddress2:resp.data[0].cu_billingaddress2,
	billingcity:resp.data[0].cu_billingcity,
	billingstate:resp.data[0].cu_billingstate,
	billingpincode:resp.data[0].cu_billingpincode,
	shippingaddress1:resp.data[0].cu_shippingaddress1, 
	shippingaddress1:resp.data[0].cu_shippingaddress2,
	shippingcity:resp.data[0].cu_shippingcity,
	shippingstate:resp.data[0].cu_shippingstate,
	shippingpincode:resp.data[0].cu_shippingpincode,	
    country:resp.data[0].cu_co_id,
    });

  }
  
});
	  
  
  
    }
	 }
handleErrorclose=(event)=>{
	  
	this.setState({open1: false});  
  } 
handleClickOpen = (e) => {
 
  this.setState({ open:!this.state.open,cu_id:0,billingaddress1:'',billingaddress2:'',billingcity:'',billingstate:'',billingpincode:'',shippingaddress1:'',shippingaddress2:'',shippingcity:'',shippingstate:'',shippingpincode:'',coutryarray:[],country:'',countrydata:[],countrylabel:'Select Country',
	  
		 });
		this.Customergetdata();
		


this.countrybind();



};
  myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  

  
  this.setState({[nam]: val});

 }
handleClose = (e) => {

 
 
 
  
	let billingaddress1 = this.state.billingaddress1;
    let billingaddress2 = this.state.billingaddress2;
	let billingcity = this.state.billingcity;  
	let billingstate = this.state.billingstate;
	let billingpincode = this.state.billingpincode;	

	let country=this.state.country;
	if(country==''){
						this.setState({errormessage:"Please Select Country",erropen:true});
						 window.scrollTo({        top: 0     })
						 return false; 
					
				}
	if(billingaddress1==''){
						this.setState({errormessage:"Please Enter Address1",erropen:true});
						 window.scrollTo({        top: 0     })
						 return false; 
					
				}
	if(billingaddress2==''){
						this.setState({errormessage:"Please Enter Address2",erropen:true});
						 window.scrollTo({        top: 0     })
						 return false; 
					
				}
	if(billingcity==''){
						this.setState({errormessage:"Please Enter City",erropen:true});
						 window.scrollTo({        top: 0     })
						 return false; 
					
				}
	if(billingstate==''){
						this.setState({errormessage:"Please Enter State",erropen:true});
						 window.scrollTo({        top: 0     })
						 return false; 
					
				}
				if(billingpincode==''){
						this.setState({errormessage:"Please Enter Zip Code",erropen:true});
						 window.scrollTo({        top: 0     })
						 return false; 
					
				}
 var formData = new FormData();
formData.append('action','addressupdate') 
 formData.append('cu_id',this.state.cu_id) 

  formData.append('cu_country_id',country) 
 formData.append('cu_shippingaddress1',billingaddress1)
formData.append('cu_shippingaddress2',billingaddress2)
formData.append('cu_shippingcity',billingcity)
formData.append('cu_shippingstate',billingstate)
formData.append('cu_shippingpincode',billingpincode)

	
formData.append('userid',localStorage.getItem("ISIuserid"))
	
	formData.append('type',1)
	 axios.post(localStorage.getItem("ISIurl")+"ajaxcustomer.php", formData, {
        }).then(res => {
			
			//this.props.updateDonenew();
			
	this.setState({errormessage:"Record Updated Successfuly",erropen:false	,
			
		open:false,
		billingaddress1:'',
		billingaddress2:'',
		billingcity:'',		
		billingstate:'',		
		billingpincode:"",
		shippingaddress1:'',
		shippingaddress2:'',
		shippingcity:'',		
		shippingstate:'',		
		shippingpincode:"",			
		cu_id:0
		});this.props.billingupdateDone();		
            });
	
	
	
};
Customergetdata() {
	
  if(this.props.id!==0)
  {
	   axios.get(localStorage.getItem("ISIurl")+'ajaxcustomer.php?action=getall&cu_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
  
      cu_id:resp.data[0].cu_id,	
	billingaddress1:resp.data[0].cu_billingaddress1,
	billingaddress2:resp.data[0].cu_billingaddress2,
	billingcity:resp.data[0].cu_billingcity,
	billingstate:resp.data[0].cu_billingstate,
	billingpincode:resp.data[0].cu_billingpincode,	
    country:resp.data[0].cu_co_id,
    });

  }
  
});
	  
  
  
    }
	 }
countrybind(){

    axios.get(localStorage.getItem("ISIurl")+'ajaxcountry.php?action=getall')
    
      .then((resp) => {   
	  
	  let CountryApi = resp.data.map(row => {
                      
          return {value: row.co_id, display:row.co_name}
        });
		
		 this.setState({
          countrydata: [{value: '', display:'Select Country'}].concat(CountryApi)
        },()=>{console.log(this.state.countrydata)});
      }).then(data => {
		 
        
      
		
       
      })


   
	  
}
 
render (){

return(
<React.Fragment>
<Dialog open={this.state.open} onClose={this.onclickbranchclose} maxWidth="xs" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Set Main Address</DialogTitle>
      <DialogContent>
	  
<div className="formlist">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
						  
		
						  
	<ul>
 <li> <p className="popformtext"></p>
		<p className="popforminputs"><FormControl  className="txtbox">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.countrylabel, value: this.state.country}}
          onChange={this.myChangeHandler}
          id="country"
		   value={this.state.country} className="txtbox"
		  name="country"
		inputProps={{tabIndex: "8"}}
		
        >
		{this.state.countrydata.map(country => (
            <option  
            
              value={country.value}
            >
              {country.display}
            </option  >
          ))}
		
        </Select></FormControl>
		</p><div className="clear"></div>
	
		
		
		
		
		
		</li>

		  

       
		  
		<li>  
		<p className="popformtext">Address1</p>
		<p className="popforminputs">
		  <TextField
            variant="outlined"
            margin="normal"
           className="txtbox"
            fullWidth
			value={this.state.billingaddress1}
            id="billingaddress1"
          inputProps={{tabIndex: "1",maxLength:150}}
            name="billingaddress1" onChange={this.myChangeHandler}
            autoComplete="billingaddress1"
            
			
          /></p>	<div className="clear"></div></li>
		  
	 
		  
		<li>  
		<p className="popformtext">Address2 </p>
		<p className="popforminputs">
		  <TextField
            variant="outlined"
            margin="normal"
           className="txtbox"
            fullWidth
			value={this.state.billingaddress2}
            id="billingaddress2"
              inputProps={{tabIndex: "2",maxLength:150}}
            name="billingaddress2" onChange={this.myChangeHandler}
            autoComplete="billingaddress2"
			
            
			
          /></p>	<div className="clear"></div></li>
		  
		 
		 
		 <li>  
		 <p className="popformtext">City</p>
		 <p className="popforminputs">
		  <TextField
            variant="outlined"
            margin="normal"
           className="txtbox"
            fullWidth
			value={this.state.billingcity}
            id="billingcity"
                  inputProps={{tabIndex: "3",maxLength:150}}
            name="billingcity" onChange={this.myChangeHandler}
            autoComplete="billingcity"
			
            
			
          /></p>	<div className="clear"></div></li>
		  
		 
		 
		 
		 
		 
		 <li>  
		 <p className="popformtext">State</p>
		 <p className="popforminputs">
		  <TextField
            variant="outlined"
            margin="normal"
           className="txtbox"
            fullWidth
			value={this.state.billingstate}
            id="billingstate"
            inputProps={{tabIndex: "4",maxLength:150}}
            name="billingstate" onChange={this.myChangeHandler}
            autoComplete="billingstate"           
			
          /></p>	<div className="clear"></div></li>
		 
		
		 
		 <li> 
<p className="popformtext">Pincode</p>
		 <p  className="popforminputs">
		  <TextField
            variant="outlined"
            margin="normal"
            inputProps={{tabIndex: "5",maxLength:10}}
            fullWidth
			value={this.state.billingpincode}
            id="billingpincode"
          className="txtbox"
            name="billingpincode" onChange={this.myChangeHandler}
            autoComplete="billingpincode"
			
            
			
          /></p>	<div className="clear"></div></li>
		  
		 
		 
		  
		  
		 
		 
		 
		
		
		<li></li>
		
		  
		  
		
		
		
		
		
		
		</ul>
		</div>
     <div className="actionbtns">
	   <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.handleClickOpen}>
Cancel
</Button>
</div> 
<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handleClose}>
   Save
</Button>
    </div> 	
<div className="clear"></div>

 </div>   		
						    </DialogContent>
      
    </Dialog>
</React.Fragment>
) }	 
}
